{
  "LABEL_MGMT": {
    "HEADER": "Štítky",
    "HEADER_BTN_TXT": "Přidat štítek",
    "LOADING": "Načítání štítků",
    "DESCRIPTION": "Štítky vám pomáhají kategorizovat a prioritizovat konverzace a potenciální zákazníky. Můžete přiřadit štítek ke konverzaci nebo kontaktu pomocí bočního panelu.",
    "LEARN_MORE": "Další informace o štítcích",
    "SEARCH_404": "Neexistují žádné položky odpovídající tomuto dotazu",
    "LIST": {
      "404": "V tomto účtu nejsou k dispozici žádné štítky.",
      "TITLE": "Spravovat štítky",
      "DESC": "Štítky vám umožňují seskupit konverzace dohromady.",
      "TABLE_HEADER": {
        "NAME": "Název",
        "DESCRIPTION": "Popis",
        "COLOR": "Barva"
      }
    },
    "FORM": {
      "NAME": {
        "LABEL": "Název štítku",
        "PLACEHOLDER": "Název štítku",
        "REQUIRED_ERROR": "Název štítku je povinný",
        "MINIMUM_LENGTH_ERROR": "Je vyžadována minimální délka 2",
        "VALID_ERROR": "Povolena jsou pouze písmena, čísla, pomlčky a podtržítka"
      },
      "DESCRIPTION": {
        "LABEL": "Popis",
        "PLACEHOLDER": "Popis štítku"
      },
      "COLOR": {
        "LABEL": "Barva"
      },
      "SHOW_ON_SIDEBAR": {
        "LABEL": "Zobrazit štítek na bočním panelu"
      },
      "EDIT": "Upravit",
      "CREATE": "Vytvořit",
      "DELETE": "Vymazat",
      "CANCEL": "Zrušit"
    },
    "SUGGESTIONS": {
      "TOOLTIP": {
        "SINGLE_SUGGESTION": "Přidat štítek ke konverzaci",
        "MULTIPLE_SUGGESTION": "Vybrat tento štítek",
        "DESELECT": "Zrušit výběr štítku",
        "DISMISS": "Odmítnout návrh"
      },
      "POWERED_BY": "AI",
      "DISMISS": "Odmítnout",
      "ADD_SELECTED_LABELS": "Přidat vybrané štítky",
      "ADD_SELECTED_LABEL": "Přidat vybraný štítek",
      "ADD_ALL_LABELS": "Přidat všechny štítky",
      "SUGGESTED_LABELS": "Navrhované štítky"
    },
    "ADD": {
      "TITLE": "Přidat štítek",
      "DESC": "Štítky vám umožňují seskupit konverzace dohromady.",
      "API": {
        "SUCCESS_MESSAGE": "Štítek byl úspěšně přidán",
        "ERROR_MESSAGE": "Došlo k chybě, zkuste to prosím znovu"
      }
    },
    "EDIT": {
      "TITLE": "Upravit štítek",
      "API": {
        "SUCCESS_MESSAGE": "Štítek byl úspěšně aktualizován",
        "ERROR_MESSAGE": "Došlo k chybě, zkuste to prosím znovu"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Vymazat",
      "API": {
        "SUCCESS_MESSAGE": "Štítek byl úspěšně odstraněn",
        "ERROR_MESSAGE": "Došlo k chybě, zkuste to prosím znovu",
        "IN_USE_ERROR": "Štítek nelze smazat, protože je používán v {usages}. Před smazáním ho nejprve odstraňte z uvedených záznamů.",
        "IN_USE_FILTERS": "filtrech: {names}",
        "IN_USE_AUTOMATIONS": "automatizacích: {names}",
        "IN_USE_MACROS": "makrech: {names}"
      },
      "CONFIRM": {
        "TITLE": "Potvrdit odstranění",
        "MESSAGE": "Opravdu chcete odstranit ",
        "YES": "Ano, odstranit ",
        "NO": "Ne, zachovat "
      }
    }
  }
}
